module.exports = __webpack_public_path__ + "static/media/fusion-ginssen-icon-01.882e9d7c.png";